import React from 'react';
import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { Button } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';

const PREFIX = 'MeetupsToolbar';

const classes = {
  root: `${PREFIX}-root`,
  row: `${PREFIX}-row`,
  spacer: `${PREFIX}-spacer`,
};

const Root = styled('div')(({ theme }) => ({
  [`&.${classes.root}`]: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
  },

  [`& .${classes.row}`]: {
    display: 'flex',
  },

  [`& .${classes.spacer}`]: {
    flexGrow: 1,
  },
}));

const MeetupsToolbar = props => {
  const { className, showAll, setShowAll, ...rest } = props;

  return (
    <Root {...rest} className={clsx(classes.root, className)}>
      <div className={classes.row}>
        <FormControlLabel
          control={
            <Checkbox
              checked={showAll}
              onChange={() => {
                setShowAll(!showAll);
              }}
              color='primary'
            />
          }
          label='Показывать закрытые'
        />

        <span className={classes.spacer} />
        <RouterLink to='/meetup/add'>
          <Button color='primary' variant='contained' data-test-id='create-meetup'>
            Создать мероприятие
          </Button>
        </RouterLink>
      </div>
    </Root>
  );
};

MeetupsToolbar.propTypes = {
  className: PropTypes.string,
};

export default MeetupsToolbar;
